import Color from 'color';
import { lFColor0, mobileRes } from 'pages/components/LFHeader/LFHeader.styled';
import styled from 'styled-components';

/** Teal response theme — distinct from purple staff-report chrome. */
export const responseAccent = '#0f766e';

export const Overlay = styled.div<{ $response?: boolean, $embedded?: boolean }>`
  /* Absolute (not fixed) so the card stays right of the REPORTING sidebar. */
  position: ${({ $embedded }) => ($embedded ? 'relative' : 'absolute')};
  inset: ${({ $embedded }) => ($embedded ? 'auto' : '0')};
  z-index: ${({ $embedded }) => ($embedded ? 1 : 12000)};
  flex: ${({ $embedded }) => ($embedded ? 1 : 'none')};
  min-height: ${({ $embedded }) => ($embedded ? 0 : 'auto')};
  background: ${({ $embedded, $response }) => {
    if ($embedded) return '#f4f5f7';
    return $response
      ? Color('#1a2e2b').alpha(0.28).toString()
      : Color('#2a2a32').alpha(0.28).toString();
  }};
  backdrop-filter: ${({ $embedded }) => ($embedded ? 'none' : 'blur(12px)')};
  -webkit-backdrop-filter: ${({ $embedded }) => ($embedded ? 'none' : 'blur(12px)')};
  display: flex;
  flex-direction: column;
  height: ${({ $embedded }) => ($embedded ? '100%' : 'auto')};
  overflow: hidden;
`;

export const TopBar = styled.div<{ $response?: boolean }>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: ${({ $response }) => ($response ? '#2a524c' : '#3a3a44')};
  border-bottom: 1px solid ${({ $response }) => (
    $response ? 'rgba(15, 118, 110, 0.28)' : 'rgba(255, 255, 255, 0.12)'
  )};
  color: #f8f8fa;
  @media (max-width: ${mobileRes}) {
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 12px;
  }
`;

export const KindPill = styled.span<{ $response?: boolean }>`
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: ${({ $response }) => (
    $response
      ? Color(responseAccent).alpha(0.22).toString()
      : Color(lFColor0).alpha(0.22).toString()
  )};
  color: ${({ $response }) => ($response ? '#5eead4' : '#d8b4fe')};
  margin-right: 8px;
  flex-shrink: 0;
`;

export const SenderPhoto = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.12);
`;

export const SenderPhotoFallback = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${Color(lFColor0).alpha(0.28).toString()};
  color: #f3e8ff;
  font-size: 15px;
  font-weight: 700;
`;

export const TitleBlock = styled.div`
  min-width: 0;
  flex: 1;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const TitleText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Sub = styled.div`
  font-size: 12px;
  color: rgba(248, 248, 250, 0.78);
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  @media (max-width: ${mobileRes}) {
    width: 100%;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
`;

export const Btn = styled.button<{ $primary?: boolean, $response?: boolean }>`
  height: 34px;
  padding: 0 12px;
  border-radius: 7px;
  border: 1px solid ${({ $primary }) => (
    $primary ? 'transparent' : 'rgba(255,255,255,0.18)'
  )};
  background: ${({ $primary, $response }) => {
    if (!$primary) return 'transparent';
    return $response ? responseAccent : lFColor0;
  }};
  color: white;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  svg {
    font-size: 16px !important;
  }
  &:hover {
    background: ${({ $primary, $response }) => {
    if (!$primary) return 'rgba(255,255,255,0.08)';
    return Color($response ? responseAccent : lFColor0).darken(0.08).toString();
  }};
  }
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const FrameWrap = styled.div<{
  $response?: boolean,
  $hideOnDesktop?: boolean,
  $hideOnMobile?: boolean,
}>`
  flex: 1;
  min-height: 0;
  background: transparent;
  display: ${({ $hideOnDesktop }) => ($hideOnDesktop ? 'none' : 'flex')};
  flex-direction: column;
  @media (max-width: ${mobileRes}) {
    display: ${({ $hideOnMobile }) => ($hideOnMobile ? 'none' : 'flex')};
  }
`;

export const PdfSetBanner = styled.div<{ $response?: boolean }>`
  flex-shrink: 0;
  padding: 9px 16px;
  font-size: 12px;
  line-height: 1.4;
  color: ${({ $response }) => ($response ? '#ccfbf1' : '#f3e8ff')};
  background: ${({ $response }) => (
    $response ? 'rgba(15, 118, 110, 0.28)' : 'rgba(121, 20, 204, 0.22)'
  )};
  border-bottom: 1px solid ${({ $response }) => (
    $response ? 'rgba(94, 234, 212, 0.22)' : 'rgba(216, 180, 254, 0.22)'
  )};
`;

export const PdfSetBannerTitle = styled.span`
  font-weight: 700;
`;

export const Frame = styled.iframe`
  width: 100%;
  flex: 1;
  min-height: 0;
  border: none;
  background: white;
`;

/** Receiver report preview (no full log dump — charts + show-logs only). */
export const PreviewWrap = styled.div<{
  $hideOnDesktop?: boolean,
  $hideOnMobile?: boolean,
  $sideBySide?: boolean,
  $hasPager?: boolean,
}>`
  flex: 1;
  min-height: 0;
  box-sizing: border-box;
  overflow: hidden;
  padding: ${({ $hasPager }) => ($hasPager ? '20px 16px 0' : '20px 16px 24px')};
  background: transparent;
  display: ${({ $hideOnDesktop }) => ($hideOnDesktop ? 'none' : 'flex')};
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  @media (max-width: ${mobileRes}) {
    display: ${({ $hideOnMobile }) => ($hideOnMobile ? 'none' : 'flex')};
    overflow: auto;
    padding: 20px 16px 24px;
  }
`;

export const PreviewCard = styled.div`
  width: 100%;
  max-width: 520px;
  flex: 1 1 360px;
  min-width: 0;
  min-height: 0;
  overflow: auto;
  background: #fff;
  border-radius: 12px;
  padding: 18px 18px 20px;
  box-sizing: border-box;
  @media (max-width: ${mobileRes}) {
    flex: none;
    overflow: visible;
    max-height: none;
  }
`;

export const PreviewSectionBlock = styled.div`
  & + & {
    margin-top: 18px;
    padding-top: 16px;
    border-top: 1px solid #e9ecef;
  }
`;

export const PreviewSectionLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 8px;
`;

/** Space Body from Purpose / context / alert summary above it. */
export const PreviewBodySection = styled.div`
  &:not(:first-child) {
    padding-top: 16px;
  }
`;

export const PreviewSubject = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.35;
  color: #1a1a1a;
  word-break: break-word;
  margin-bottom: 14px;
`;

export const PreviewDescription = styled.div`
  font-size: 14px;
  line-height: 1.55;
  color: #1a1a1a;
  white-space: pre-wrap;
  word-break: break-word;
`;

const reportLogBlue = '#2563eb';
const reportLogBlueSoft = Color(reportLogBlue).alpha(0.08).toString();
const reportLogBlueMid = Color(reportLogBlue).alpha(0.12).toString();
const reportLogBlueBorder = Color(reportLogBlue).alpha(0.4).toString();

export const PreviewBodyStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PreviewLogGroup = styled.div`
  border: 1px solid ${reportLogBlueBorder};
  border-radius: 8px;
  background: ${reportLogBlueSoft};
  overflow: hidden;
`;

export const PreviewLogRow = styled.div<{ $clickable?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid ${reportLogBlueBorder};
  width: 100%;
  box-sizing: border-box;
  background: transparent;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  &:last-child {
    border-bottom: none;
  }
  ${({ $clickable }) => ($clickable ? `
    &:hover {
      background: ${reportLogBlueMid};
    }
  ` : '')}
`;

export const PreviewLogMain = styled.div`
  min-width: 0;
  flex: 1;
`;

export const PreviewLogMessage = styled.div<{ $clamp?: boolean }>`
  font-size: 13px;
  line-height: 1.4;
  color: #1a1a1a;
  ${({ $clamp }) => $clamp && `
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  `}
`;

export const PreviewLogDate = styled.div`
  font-size: 11px;
  line-height: 1.35;
  color: #6b7280;
  margin-bottom: 4px;
`;

/** Shared width with the group total figure so amounts line up. */
export const PreviewLogValue = styled.div<{ $na?: boolean }>`
  flex-shrink: 0;
  box-sizing: border-box;
  width: 96px;
  padding-top: 1px;
  font-size: 13px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ $na }) => ($na ? '#9aa0a8' : '#1a1a1a')};
`;

export const PreviewLogGroupTotal = styled.div<{ $clickable?: boolean }>`
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding: 10px 12px;
  border-top: 1px solid ${reportLogBlueBorder};
  background: ${reportLogBlueMid};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  ${({ $clickable }) => ($clickable ? `
    &:hover {
      background: ${Color(reportLogBlue).alpha(0.18).toString()};
    }
  ` : '')}
`;

export const PreviewLogGroupTotalTerm = styled.span`
  min-width: 0;
  flex: 1;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${reportLogBlue};
`;

export const PreviewLogGroupTotalFigure = styled.span`
  flex-shrink: 0;
  box-sizing: border-box;
  width: 96px;
  font-size: 13px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #1a1a1a;
`;

export const PreviewLogsRow = styled.div`
  margin-bottom: 14px;
  padding-top: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e9ecef;
`;

export const PreviewLogsCount = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #4b5563;
  line-height: 1.55;
`;

export const PreviewLogsLink = styled.button`
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  display: inline;
  font-size: inherit;
  font-weight: 700;
  color: ${lFColor0};
  cursor: pointer;
  font-family: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
  &:hover {
    color: ${Color(lFColor0).darken(0.1).toString()};
  }
`;

export const PreviewCharts = styled.div`
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
`;

export const PreviewMetricsNote = styled.div<{ $warn?: boolean }>`
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid ${({ $warn }) => (
    $warn ? 'rgba(180, 83, 9, 0.35)' : 'rgba(37, 99, 235, 0.35)'
  )};
  background: ${({ $warn }) => (
    $warn ? 'rgba(180, 83, 9, 0.08)' : 'rgba(37, 99, 235, 0.06)'
  )};
  font-size: 12px;
  line-height: 1.45;
  color: #4b5563;
`;

export const PreviewMetricsNoteTitle = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 4px;
`;

export const Empty = styled.div`
  flex: 1;
  min-height: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(248, 248, 250, 0.8);
  font-size: 14px;
  padding: 24px;
  text-align: center;
`;

export const MobileSectionTabs = styled.div`
  display: none;
  @media (max-width: ${mobileRes}) {
    display: flex;
    flex-shrink: 0;
    gap: 6px;
    padding: 8px 12px;
    background: #45454f;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
`;

export const MobileSectionTab = styled.button<{ $active?: boolean }>`
  flex: 1;
  height: 34px;
  border: none;
  border-radius: 7px;
  background: ${({ $active }) => ($active ? lFColor0 : 'transparent')};
  color: ${({ $active }) => ($active ? '#fff' : 'rgba(248, 248, 250, 0.82)')};
  font-size: 12px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
`;

export const DesktopOnly = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  @media (max-width: ${mobileRes}) {
    display: none;
  }
`;

export const ThreadStack = styled.div<{ $sideBySide?: boolean }>`
  display: flex;
  flex-direction: ${({ $sideBySide }) => ($sideBySide ? 'row' : 'column')};
  flex-wrap: nowrap;
  align-items: stretch;
  justify-content: center;
  gap: ${({ $sideBySide }) => ($sideBySide ? '16px' : '12px')};
  width: 100%;
  max-width: ${({ $sideBySide }) => ($sideBySide ? '1100px' : '520px')};
  flex: 1;
  min-height: 0;
  align-self: center;
  @media (max-width: ${mobileRes}) {
    flex-direction: column;
    max-width: 520px;
    flex: none;
    gap: 12px;
  }
`;

export const ThreadMessageHead = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
`;

export const ThreadMessageMeta = styled.div`
  min-width: 0;
  flex: 1;
`;

export const ThreadMessageName = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 13px;
  font-weight: 700;
  color: #1a1a1a;
`;

export const CardKindPill = styled.span<{ $response?: boolean }>`
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 7px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: ${({ $response }) => (
    $response
      ? Color(responseAccent).alpha(0.12).toString()
      : Color(lFColor0).alpha(0.12).toString()
  )};
  color: ${({ $response }) => ($response ? responseAccent : lFColor0)};
  flex-shrink: 0;
`;

export const ThreadMessageWhen = styled.div`
  font-size: 11px;
  color: #6b7280;
  margin-top: 2px;
`;

export const MobileSection = styled.div<{ $visible?: boolean }>`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  @media (max-width: ${mobileRes}) {
    display: ${({ $visible }) => ($visible ? 'flex' : 'none')};
  }
`;

export const PagesCont = styled.div`
  flex-shrink: 0;
  margin-top: 12px;
  padding: 10px 12px;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-top: 1px solid #e5e7eb;
  @media (max-width: ${mobileRes}) {
    margin-top: 16px;
  }
`;

export const PagesCont1 = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
`;

/** In-viewer confirm — sits above the report chrome so File / Dismiss stay in context. */
export const ConfirmScrim = styled.div`
  position: absolute;
  inset: 0;
  z-index: 8;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
  background: rgba(26, 26, 32, 0.42);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
`;

export const ConfirmCard = styled.div`
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 18px 48px rgba(17, 24, 39, 0.22);
  padding: 22px 22px 18px;
  color: #374151;
`;

export const ConfirmTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.01em;
  line-height: 1.3;
`;

export const ConfirmBody = styled.div`
  margin-top: 10px;
  font-size: 13.5px;
  line-height: 1.5;
  color: #4b5563;
`;

export const ConfirmNote = styled.div`
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f5f3ff;
  border: 1px solid rgba(121, 20, 204, 0.16);
  font-size: 12.5px;
  line-height: 1.45;
  color: #4c1d95;
`;

export const ConfirmActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
`;

export const ConfirmCancelBtn = styled.button`
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1.5px solid #e5e7eb;
  background: #fff;
  color: #4b5563;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  &:hover {
    background: #f9fafb;
  }
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const ConfirmActBtn = styled.button<{ $response?: boolean }>`
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  border: none;
  background: ${({ $response }) => ($response ? responseAccent : lFColor0)};
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  &:hover {
    background: ${({ $response }) => Color($response ? responseAccent : lFColor0).darken(0.08).toString()};
  }
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

